module.exports = __webpack_public_path__ + "static/shop-earn-cash-back-9852e6ed33d23c09abf1a4e3c99d83d6.png";